import http from "@/libs/http";
const exports = {
  /**俱乐部比赛列表导出 */
  exportClub: ClubPageListVO => {
    return http.get(http.formatUrl("export/club"), ClubPageListVO);
  },
  /**足球列表导出 */
  exportFootball: FootBallPageListVO => {
    return http.get(http.formatUrl("export/football"), FootBallPageListVO);
  },
  /**中央本级赛事/训练营列表导出 */
  exportGameCenter: GamePageListVO => {
    return http.get(http.formatUrl("export/game/center"), GamePageListVO);
  },
  /**转移支付赛事/训练营列表导出 */
  exportGameProvince: GamePageListVO => {
    return http.get(http.formatUrl("export/game/province"), GamePageListVO);
  },
  /* 传统校比赛列表导出 */
  exportTraditionalschool: SchoolPageListVO => {
    return http.get(http.formatUrl("export/traditionalschool"), SchoolPageListVO);
  },
  /**后备人才培养列表导出 */
  exportTrainingbase: BasePageListVO => {
    return http.get(http.formatUrl("export/trainingbase"), BasePageListVO);
  },
  /**训练营列表导出 */
  exportTrainingcamp: GamePageListVO => {
    return http.get(http.formatUrl("export/trainingcamp"), GamePageListVO);
  },
  /**教练员培训列表导出 */
  exportTrainingclass: ClassPageListVO => {
    return http.get(http.formatUrl("export/trainingclass"), ClassPageListVO);
  },
  /**U系列比赛列表导出 */
  exportUgame: GamePageListVO => {
    return http.get(http.formatUrl("export/ugame"), GamePageListVO);
  },
  /**其他类型计划导出 */
  exportPlanOther: PlanOtherPageListVO => {
    return http.get(http.formatUrl("export/plan/other"), PlanOtherPageListVO);
  },
  // 体育赛事备案导出
  exportgame_filing: gameFilingPageListVO => {
    return http.get(http.formatUrl("export/game_filing"), gameFilingPageListVO);
  }
};
export default exports;
